export enum UserRole {
  AD = 'Administrator',
  AN = 'Analyst',
  AU = 'Auditor',
  MA = 'Management',
  SA = 'SAR Team',
  UA = 'User Administrator'
}
